import script from "./Pagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./Pagination.vue?vue&type=script&lang=ts&setup=true"

import "./Pagination.vue?vue&type=style&index=0&id=dc2642b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc2642b2"]])

export default __exports__